<script>
export default {
  name: "HyperlinkDashboard",
  functional: true,
  props: {
    OpenSelection: {
      type: Function
    },
    row: {
      type: Object
    },
    column: {
      type: String
    },
    rowValue: {
      type: [String, Number, Object, Array, Function],
      require: false
    },
    getType: {
      type: Function,
      require: false
    },
    month: {
      type: Number,
      require: false
    },
    mes: {
      type: Number
    }
  },
  render(createElement, context) {
    const { isTotal } = context.props;
    let classs = "";
    function setClassColor(props) {
      if (!props.getType) {
        const value = props.row[props.column];

        if (value < 80) {
          return "red";
        } else if (value >= 80 && value <= 99) {
          return "golden";
        } else if (value > 99) {
          return "green";
        }
      }
    }

    classs = setClassColor(context.props);

    function displayValue(props) {
      const actualDate = new Date();
      const actualMonth = actualDate.getMonth() + 1;
      let value = "";
      if (!props.getType) {
        if (props.row[props.column] > 0 || props.mes <= actualMonth) {
          value = `${props.row[props.column]}` + `.00%`;
        }

        return value;
      }
    }
    if (isTotal) {
      return createElement("span", {}, displayValue(context.props));
    }
    return createElement(
      "a",
      {
        attrs: {
          name: "",
          href: "#",
          class: classs
        },
        on: {
          click: () => {
            context.props.OpenSelection(context.props);
          }
        }
      },
      displayValue(context.props)
    );
  }
};
</script>

<style lang="scss" scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.golden {
  color: goldenrod;
}
</style>
